import React, {useEffect,useState, useMemo} from 'react'
import { Menu as UikitMenu } from '@pancakeswap/uikit'
import { languageList } from 'config/localization/languages'
import { useTranslation } from 'contexts/Localization'
import useTheme from 'hooks/useTheme'
import { useProfile } from 'state/profile/hooks'
import { formatNumber } from 'utils/formatBalance'
import { useEggPrice } from 'state/egg/hooks'
import config, { socials } from './config'
import UserMenu from './UserMenu'
import GlobalSettings from './GlobalSettings'
import {useCakeBusdPrice} from "../../hooks/useBUSDPrice";
import {fetch5xDataAsync} from "../../state/miner5x";
import useFetchState from "../../hooks/useFetchState";
import useActiveWeb3React from "../../hooks/useActiveWeb3React";

const Menu = (props) => {
  const { isDark, toggleTheme } = useTheme()
  const cakePriceUsd = useCakeBusdPrice()
  const cakePriceUsdDisplay = cakePriceUsd ? cakePriceUsd.toFixed(6) : '0'
  const { profile } = useProfile()
  const { currentLanguage, setLanguage, t } = useTranslation()

  return (
    <UikitMenu
      userMenu={<UserMenu />}
      globalMenu={<GlobalSettings />}
      isDark={isDark}
      toggleTheme={toggleTheme}
      currentLang={currentLanguage.code}
      langs={languageList}
      setLang={setLanguage}
      cakePriceUsd={Number(cakePriceUsdDisplay)}
      links={config(t)}
      socials={socials}
      profile={{
        username: profile?.username,
        image: profile?.nft ? `/images/nfts/${profile.nft?.images.sm}` : undefined,
        profileLink: '/profile',
        noProfileLink: '/profile',
        showPip: !profile?.username,
      }}
      {...props}
    />
  )
}

export default Menu
